import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServiceCard.css';

function ServiceCard({ icon, title, description, linkTo, linkLabel }) {
  const navigate = useNavigate();

  return (
    <div
      className={`service-card card${linkTo ? ' service-card--clickable' : ''}`}
      onClick={linkTo ? () => navigate(linkTo) : undefined}
      role={linkTo ? 'button' : undefined}
      tabIndex={linkTo ? 0 : undefined}
      onKeyDown={linkTo ? (e) => { if (e.key === 'Enter') navigate(linkTo); } : undefined}
    >
      {icon && <div className="service-card__icon">{icon}</div>}
      <h3 className="service-card__title">{title}</h3>
      <p className="service-card__desc">{description}</p>
      {linkTo && linkLabel && (
        <span className="service-card__link">{linkLabel} &rarr;</span>
      )}
    </div>
  );
}

export default ServiceCard;
